const COLUMNAS_EXCEL = [
    {
        value: 0,
        label: "CODE",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 1,
        label: "LICENCE PLATE",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
    {
        value: 2,
        label: "LABEL",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 3,
        label: "TYPE VEHICLE",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 4,
        label: "BRAND",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 5,
        label: "MODEL",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 6,
        label: "YEAR",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 7,
        label: "FUEL",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
];

const INDEX_COLUMNAS_EXCEL = {
    CODE: 0,
    LICENCE_PLATE: 1,
    LABEL: 2,
    TYPE_VEHICLE: 3,
    BRAND: 4,
    MODEL: 5,
    YEAR: 6,
    FUEL: 7,
};

const COLUMNAS_EXCEL_STRING = {
    CODE: "CODE",
    LICENCE_PLATE: "LICENCE_PLATE",
    LABEL: "LABEL",
    TYPE_VEHICLE: "TYPE_VEHICLE",
    BRAND: "BRAND",
    MODEL: "MODEL",
    YEAR: "YEAR",
    FUEL: "FUEL",
};

export {
    COLUMNAS_EXCEL,
    INDEX_COLUMNAS_EXCEL,
    COLUMNAS_EXCEL_STRING,
}